<template>
  <v-app>
    <v-navigation-drawer persistent v-model="drawer" enable-resize-watcher fixed app dark>
      <v-list class="pt-0">
        <v-list-tile class="py-2 mb-3 primary header">
          <img src="@/assets/citi.png" alt="citiserve">
        </v-list-tile>

        <v-list-group prepend-icon="group_add" class="mb-3">
          <v-list-tile slot="activator">
            <v-list-tile-title>Create New</v-list-tile-title>
          </v-list-tile>

          <v-list-tile
            v-for="(item, index) in createNew"
            :key="index"
            :to="item.route"
            class="mb-2 pl-5"
          >
            <v-list-tile-action>
              <v-icon v-html="item.icon"></v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <h4 v-text="item.title" class="font-weight-regular"></h4>
              <v-divider></v-divider>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <v-list-tile
          class="mb-3"
          value="true"
          v-for="(item, i) in menuItems"
          :key="i"
          :to="item.route"
        >
          <v-list-tile-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="white--text" v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app class="secondary" dark>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <v-btn slot="activator" dark flat icon>
          <v-badge color="primary" right overlap class="mt-1">
            <span slot="badge" dark small v-text="notifications.length"></span>
            <v-icon color="white">mail</v-icon>
          </v-badge>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="(notification, index) in notifications"
            :key="index"
            @click="gotoLink(index, notification.url)"
            class="mb-2"
          >
            <v-list-tile-content>
              <!-- <h4
                v-text="notification.from"
              class="font-weight-light"></h4>-->
              <h5 v-text="notification.message" class="font-weight-regular"></h5>
              <v-divider></v-divider>
            </v-list-tile-content>
            <!-- <router-link :to="notification.url" class="secondary--text">
            </router-link>-->
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-menu offset-y>
        <v-btn slot="activator" flat>
          Welcome, {{firstname}}
          <v-icon dark>arrow_drop_down</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile @click="logout()">
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <!-- <span v-text="'Welcome, '+ firstname"></span> -->
    </v-toolbar>
    <v-content>
      <!-- <router-view></router-view> -->
      <slot/>
      <notification-bar></notification-bar>
    </v-content>
    <!-- <v-footer :fixed="fixed" app>
      <span>&copy; 2017</span>
    </v-footer>-->
  </v-app>
</template>

<script>
import NotificationBar from "./notification";
import { AUTH_LOGOUT } from "@/store/actions/auth";
import {
  CLEAR_NOTIFICATION,
  CLEAR_ALL_NOTIFICATIONS
} from "@/store/actions/common";

export default {
  name: "AdminLayout",
  components: { NotificationBar },
  data() {
    return {
      drawer: true,
      menuItems: [
        {
          title: "Route Marshals",
          icon: "recent_actors",
          route: "/admin/route-marshals"
        },
        {
          title: "Merchants",
          icon: "people",
          route: "/admin/merchants"
        },
        {
          title: "Bank Reports",
          icon: "feedback",
          route: "/admin/reports"
        },
        {
          title: "Analytics",
          icon: "trending_up",
          route: "/admin/analytics"
        }
      ],
      createNew: [
        {
          title: "New Route Marshal",
          icon: "face",
          route: "/admin/create/marshal"
        },
        {
          title: "New Merchant Location",
          icon: "add_location",
          route: "/admin/create/merchantLocation"
        },
        {
          title: "New Merchant",
          icon: "people_outline",
          route: "/admin/create/merchant"
        }
      ],
      title: "PTSP Admin Dashboard"
    };
  },
  computed: {
    notifications() {
      return this.$store.state.common.notifications;
    },
    firstname() {
      return this.$store.getters.getProfile.first_name;
    }
  },
  methods: {
    logout() {
      return this.$store
        .dispatch(AUTH_LOGOUT)
        .then(() => this.$router.push("/"));
    },
    gotoLink(index, url) {
      // add @hide or close to v-menu to clear all notifications
      this.$router.push(url);
      this.$store.dispatch(CLEAR_NOTIFICATION, index);
    }
  }
};
</script>

<style scoped>
.header img {
  width: 100%;
}

a {
  text-decoration: none;
}
</style>

